import generalUpload from "../_section/upload.class";

export class userProofOfDepositInBank extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}
const template= {
    items: [
        {
            name: 'documentDate',
            label: 'Document Date',
            type: 'date',
        }, {
            name: 'closingBalance',
            label: 'Closing Balance',
            type: 'currency'
        },
        {
            name: 'bankName',
            label: 'Friendly Name (eg Sam\'s AIB Savings)',
            type: 'text'
        }
    ]
}
export class adminProofOfDepositInBank extends userProofOfDepositInBank {

    constructor(request, upload, queries) {
        super(request, upload, queries);

        this.calcValues(template)
        if (this.values.documentDate) {

            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(2,'month'),
            })
        }
    }
}
